import moment from "moment";
import {addTrailingZeros} from "@js-app/services/helpers/math";

export class BillInfo {
    billInfoData = {};

    constructor(billInfoData = {}) {
        this.billInfoData = billInfoData;
    }

    get order() {
        try {
            return this.billInfoData.order;
        } catch (e) {
            return "";
        }
    }

    get currency() {
        try {
            return this.billInfoData.currency;
        } catch (e) {
            return "";
        }
    }

    get lang() {
        try {
            return this.billInfoData.lang;
        } catch (e) {
            return "";
        }
    }

    get purpose() {
        try {
            return this.billInfoData.purpose;
        } catch (e) {
            return "";
        }
    }

    get createdAt() {
        try {
            return moment(this.billInfoData.dt).format("YYYY.MM.DD HH:mm:ss");
        } catch (e) {
            return "";
        }
    }

    get amount() {
        try {
            return addTrailingZeros((parseInt(this.billInfoData.sm) / 100).toLocaleString());
        } catch (e) {
            return "";
        }
    }

    get  expireAt() {
        try {
            return moment(this.billInfoData.exp_dt).format("YYYY.MM.DD");
        } catch (e) {
            return "";
        }
    }

    get phone() {
        try {
            return this.billInfoData.phone.replace("380", "0");
        } catch (e) {
            return "";
        }
    }

    get email() {
        try {
            return this.billInfoData.email;
        } catch (e) {
            return "";
        }
    }

    get link() {
        try {
            return this.billInfoData.bill_link;
        } catch (e) {
            return "";
        }
    }

    get comment() {
        try {
            return this.billInfoData.comment;
        } catch (e) {
            return "";
        }
    }

}
